export default __webpack_public_path__ + "static/media/arrow-chevron-down.69d3655e.svg";